'use strict';

export default () => {
  'ngInject';

  const durationMap = {
    '1month': '1 month',
    '3month': '3 months',
    '12month': '1 year',
  };

  return (duration) => {

    return durationMap[duration];
  };
};



// WEBPACK FOOTER //
// ./app/src/filters/duration.js